var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tournament-contact"},[_c('div',{staticClass:"tournament-contact__icon"},[_c('Icon',{attrs:{"name":_vm.icon,"group":"general","size":18}})],1),_c('a',{staticClass:"tournament-contact__link",attrs:{"target":"_blank","href":_vm.link}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }